
import { computed, defineComponent, reactive } from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { IProdutoKitItem } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import SelecionarProduto from './SelecionarProduto.vue';
import SelecionarUnidadeProdutoMovimento from './Unidades/SelecionarUnidadeProdutoMovimento.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';

export default defineComponent({
  name: 'ProdutoItensKit',
  props: {
    codigoProdutoDefinicao: {
      type: Number,
      required: true,
    },
    itens: {
      type: Array as () => IProdutoKitItem[],
      required: true,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
    editavel: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    MensagemSemDados,
    Icone,
    SelecionarProduto,
    SelecionarUnidadeProdutoMovimento,
    CampoNumerico,
  },
  emits: ['update:itens'],
  setup(props, { emit }) {
    const { apresentarMensagemAlerta } = useTelaBase();

    const state = reactive({
      produtoSelecionado: 0,
      unidadeSelecionada: 0,
      descricaoProduto: '',
      descricaoUnidade: '',
      quantidade: 0,
      casasDecimais: 0,
      carregandoUnidade: false,
    });

    const computedItens = computed({
      get: () => props.itens,
      set: (valor: IProdutoKitItem[]) => {
        emit('update:itens', valor);
      },
    });

    function adicionarItem() {
      if (state.produtoSelecionado === 0) {
        apresentarMensagemAlerta('O produto deve ser selecionado!');
        return;
      }

      if (state.unidadeSelecionada === 0) {
        apresentarMensagemAlerta('A unidade deve ser selecionada!');
        return;
      }

      if (state.quantidade === 0) {
        apresentarMensagemAlerta('A quantidade deve ser informada!');
        return;
      }

      if (state.produtoSelecionado === props.codigoProdutoDefinicao) {
        apresentarMensagemAlerta('O produto não pode ser o mesmo do Kit!');
        return;
      }

      const item = {} as IProdutoKitItem;
      item.codigoProdutoDefinicao = state.produtoSelecionado;
      item.codigoUnidade = state.unidadeSelecionada;
      item.descricaoProduto = state.descricaoProduto;
      item.descricaoUnidade = state.descricaoUnidade;
      item.quantidade = state.quantidade;
      item.casasDecimais = state.casasDecimais;
      computedItens.value.push(item);

      state.produtoSelecionado = 0;
      state.unidadeSelecionada = 0;
      state.descricaoProduto = '';
      state.descricaoUnidade = '';
      state.quantidade = 0;
      state.casasDecimais = 0;
    }

    function removerItem(index: number) {
      computedItens.value.splice(index, 1);
    }

    return {
      props,
      state,
      computedItens,
      UtilitarioGeral,
      adicionarItem,
      removerItem,
    };
  },
});
